import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';
import Select from 'react-select'
import TextareaAutosize from 'react-textarea-autosize';

interface IFormProps {
  id: number,
  setForEdit: any
  setClose: any
}
interface MyStates {
  ajaxLoaded: boolean,
  datas: object, 
  main_image: string,
  gallery: object,
  spinner: string,
  file_temp: any,
  types: object,
  depedencies: object,
  depedencies_selected: object,
  tax_exemption: boolean
}
export default class EditService extends React.Component<IFormProps, MyStates>{
  private depedencies_temp = [];
  private depedencies = [];
  

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      ajaxLoaded: false,
      datas: {},
      main_image: '', 
      gallery: {}, 
      spinner: 'flex',
      file_temp: {},
      types: {},
      depedencies: {},
      depedencies_selected: {},
      tax_exemption: false
    }
    if( this.props.id > 0 ){
      this.getData()
    }
  }

  private getData() {
    var ajax = new Ajax(window.location.origin+ '/reservatio/szolgaltatasok/get/' + this.props.id);
    ajax.doPost('new_place', true).then((response) => {
      if( response.status !== undefined && response.status === 'success'){
        this.setState({
          datas: response.datas, 
          main_image: response.main_image, 
          gallery: response.gallery, 
          depedencies_selected: { ...response.depedencies_selected},
          types: response.types, 
          depedencies: response.depedencies,
          spinner: 'none',
          tax_exemption: response.datas['is_tax_exemption'] == 'yes' ? true : false
        })
      } else {
        swal({
          title: "Hiba történt!",
          text: "A szolgáltatás nem található!",
          icon: "error",
        });
        this.props.setForEdit(0)
      }
    })
  }

  private handleSubmit(e){
    e.preventDefault();

    var ajax = new Ajax(window.location.origin+ '/reservatio/szolgaltatasok/update/' + this.props.id);
    ajax.doPost('edit_place', true).then((response) => {
      if( response.status !== undefined && response.status === 'success' ){
        swal({
          title: "Siker!",
          text: "A szolgáltatás módosítva!",
          icon: "success",
        });
      } else {
        swal({
          title: "Hiba történt!",
          text: "A szolgáltatás nem lett hozzáadva!",
          icon: "error",
        });
      }
    })
  }

  private statusOptions(input) {
    let values = {}
    if( input !== undefined && input !== null ){
      Object.keys(input).map((i) => (
        values[i] = input[i].value
      ))
    }
    this.setState({depedencies_selected: values})
  }

  

  private uploadMainImage(input){
    input.persist()
    this.setState({
      spinner: 'flex',
    }, () => {
      var ajax = new Ajax(  window.location.origin + '/reservatio/szolgaltatasok/uploadMainImage/'+this.props.id );
      ajax.doUpload(input).then((response) => {
        input.target.value = ''
        this.setState({ main_image: response.image, spinner: 'none', })
      })
    })
  }

  private uploadGalleryImages(input){
    input.persist()
    this.setState({
      spinner: 'flex',
    }, () => {
      var ajax = new Ajax(  window.location.origin + '/reservatio/szolgaltatasok/uploadGalleryImages/'+this.props.id );
      ajax.doUpload(input).then((response) => {
        input.target.value = ''
        this.setState({ gallery: response, spinner: 'none', })
      })
    })
  }

  private removeGalleryItem(id){
    swal({
        title: "Biztos, hogy törli ezt a szálláshelyet a listáról?",
        icon: "warning",
        buttons: {
            confirm: {
              text: "Igen",
              value: true,
              visible: true,
              className: "float-right btn-success",
              closeModal: true
            },
            cancel: {
              text: "Mégse",
              value: false,
              visible: true,
              className: "float-left btn-danger",
              closeModal: true,
            }
        }
    })
    .then((willDelete) => {
        if (willDelete) {
          this.setState({
            spinner: 'flex'
          }, () => {
            var ajax = new Ajax(window.location.origin + '/reservatio/szolgaltatasok/deleteGalleryItem/'+id);
            ajax.doPost({}).then((response) => {
              this.setState({ gallery: response, spinner: 'none' })
            })
          })
        }
    });
  }


  private close(){
    this.props.setClose(true)
  }


  private tax_exemption_change(){
    this.setState({
      tax_exemption: !this.state.tax_exemption
    })
  }

  public render() {
    if( this.props.id > 0 ){
      let can_be_donation = this.state.datas['can_be_donation'] ?? ''
      let multiply_by_quests = this.state.datas['multiply_by_quests'] ?? ''
      let observe_liturgical_events = this.state.datas['observe_liturgical_events'] ?? ''
      let add_vat = this.state.datas['add_vat'] ?? ''
      let only_company_see = this.state.datas['only_company_see'] ?? ''
      let is_tax_exemption = this.state.datas['is_tax_exemption'] ?? ''
      let tax_exemption_type = this.state.datas['tax_exemption_type'] ?? ''

      

      
      Object.keys(this.state.depedencies).map((i) => {
        let dependency = this.state.depedencies[i]
        this.depedencies[i] = {value: dependency.id, label: dependency.name}
        if ( this.checkObjValue(this.state.depedencies_selected, dependency.id) ) {
          this.depedencies_temp[i] = {value: dependency.id, label: dependency.name}
        } else {
          if( this.depedencies_temp[i] !== undefined ){
            delete this.depedencies_temp[i]
          }
        }
      })


      return (
      <>
      <div className="box" key={"edit_" + this.props.id}>
        <div className="box-header">
          <h3 className="box-title">Szolgáltatás módosítása</h3>
          <button type="button" style={{marginTop:"-3px"}} onClick={() => this.close()} className="btn btn-xs pull-right btn-danger"><i className="fa fa-window-close"></i></button>
        </div>
        <div className="box-body" style={{position: 'relative'}}>
          <div className="spinner-fill" style={{display: this.state.spinner}}>
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
          <form id="edit_place" onSubmit={(e) => this.handleSubmit(e)}>
            <div className="row">
              <div className="col-md-6 form-group">
                <input type="text" name="name" defaultValue={this.state.datas['name'] ?? ''} className="form-control" placeholder="Megnevezés" required />
              </div>
              <div className="col-md-6 form-group">
                <input type="text" name="code" defaultValue={this.state.datas['code'] ?? ''} className="form-control" placeholder="Kód" required />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 form-group">
                <TextareaAutosize name="description" className="form-control" placeholder="Leírás" defaultValue={this.state.datas['description'] ?? ''} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <div className="input-group" key={"type_id_" + (this.state.datas['type_id'] ?? '')}>
                  <span className="input-group-addon width-150px">
                  Típus:
                  </span>	
                  <select className="form-control" name="type_id" defaultValue={this.state.datas['type_id'] ?? ''}>
                    {
                      Object.keys(this.state.types).length > 0 ?
                      <>
                        {
                          Object.keys(this.state.types).map((i) => {
                            let type = this.state.types[i]
                            return (
                              <option value={type.id} key={'types_'+type.id}>{type.name}</option>
                            )
                          })
                        }
                      </>
                      :
                      <></>
                    }
                  </select>
                </div>
              </div>
              <div className="col-md-6 form-group">
                <div className="input-group" key={"service_event_" + (this.state.datas['service_event'] ?? '')}>
                  <span className="input-group-addon width-100px">
                    Szolgáltatás:
                  </span>	
                  <select className="form-control" name = "service_event" defaultValue={this.state.datas['service_event'] ?? ''}>
                    <option value={1}>Bérleti szolgáltatás</option>
                    <option value={2}>Egyéb vallásturisztikai szolgáltatás</option>
                    <option value={3}>Liturgikus esemény</option>
                    <option value={4}>Egyéb</option>
                  </select>
                </div>
              </div>
              <div className="col-md-6 form-group">
                <div className="input-group" key={"status_" + (this.state.datas['status'] ?? '')}>
                  <span className="input-group-addon width-150px">
                    Státusz:
                  </span>	
                  <select name="status" defaultValue={this.state.datas['status'] ?? ''} className="form-control">
                    <option value="active">Aktív</option>
                    <option value="inactive">Inaktív</option>
                  </select>
                </div>
              </div>
              <div className="col-md-6 form-group">
                <div className="input-group">
                  <span className="input-group-addon width-100px">
                    Időtartam:
                  </span>	
                  <input type="number" name="period" defaultValue={this.state.datas['period'] ?? ''} className="form-control" required />
                  <span className="input-group-addon bg-white">
                    perc
                  </span>	
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <div className="input-group">
                  <span className="input-group-addon width-150px">
                  Mennyiségi egység:
                  </span>	
                  <input type="text" name="unit" defaultValue={this.state.datas['unit'] ?? ''} className="form-control" required />
                </div>
              </div>
              <div className="col-md-6 form-group">
                <div className="input-group">
                  <span className="input-group-addon width-100px">
                    Ár:
                  </span>	
                  <input type="number" name="price" defaultValue={this.state.datas['price'] ?? ''} className="form-control" required />
                  <span className="input-group-addon bg-white">
                    Ft
                  </span>	
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 form-group">
                <div className="input-group">
                  <span className="input-group-addon width-410px">
                    Minimum mennyi idővel előre foglalandó:
                  </span>	
                  <input type="number" name="minimum_remaining_days" defaultValue={this.state.datas['minimum_remaining_days'] ?? ''} className="form-control" required />
                  <span className="input-group-addon bg-white">
                    nap
                  </span>	
                </div>
              </div>
            </div>
            <div className="row">
              {/* <div className="col-md-6 form-group">
                <div className="input-group">
                  <span className="input-group-addon height-34px">
                  Adományért is igénybe vehető:
                  </span>	
                  <span className="input-group-addon" key={"access_" + can_be_donation}>
                    <input type="checkbox" name="can_be_donation" defaultChecked={ can_be_donation == 'yes' ? true : false } />
                  </span>	
                </div>
              </div> */}
              <div className="col-md-6 form-group">
                <div className="input-group">
                <div className="input-group">
                  <span className="input-group-addon height-34px">
                  Szálláslétszámmal szorzandó:
                  </span>	
                  <span className="input-group-addon" key={"access_" + multiply_by_quests}>
                    <input type="checkbox" name="multiply_by_quests" defaultChecked={ multiply_by_quests == 'yes' ? true : false } />
                  </span>	
                </div>
                </div>
              </div>
              <div className="col-md-6 form-group">
                <div className="input-group">
                  <div className="input-group">
                    <span className="input-group-addon height-34px">
                    Csak vállalkozónak jelenik meg:
                    </span>	
                    <span className="input-group-addon" key={"only_company_see_" + only_company_see}>
                    <input type="checkbox" name="only_company_see"  defaultChecked={ only_company_see == 'yes' ? true : false }/>
                    </span>	
                  </div>
                </div>
              </div>
              
            </div>
            <div className="row">
              {/* <div className="col-md-12 form-group">
                <div className="input-group" style={{zIndex: 200}} key={'depedeny_' +this.joinObj(this.state.depedencies_selected)}>
                  <span className="input-group-addon width-150px">
                  Függőség:
                  </span>	
                  <Select options={this.depedencies} placeholder="Függőségek" defaultValue={this.depedencies_temp} isMulti closeMenuOnSelect={false} onChange={(e) => this.statusOptions(e)} />
                </div>
              </div> */}
              <div className="col-md-7 form-group">
                <div className="input-group">
                <div className="input-group">
                  <span className="input-group-addon height-34px">
                  Liturgikus események figyelembe vétele
                  </span>	
                  <span className="input-group-addon" key={"access_" + observe_liturgical_events}>
                    <input type="checkbox" name="observe_liturgical_events" defaultChecked={ observe_liturgical_events == 'yes' ? true : false } />
                  </span>	
                </div>
                </div>
              </div>
              <div className="col-md-5 form-group">
                <div className="input-group">
                <div className="input-group">
                  <span className="input-group-addon height-34px">
                    Áfa hozzáadandó: 
                  </span>	
                  <span className="input-group-addon" key={"add_vat_" + add_vat}>
                    <input type="checkbox" name="add_vat" defaultChecked={ add_vat == 'yes' ? true : false } />
                  </span>	
                </div>
                </div>
              </div>

              <div className="col-md-4 form-group">
              <div className="input-group">
              <div className="input-group">
                <span className="input-group-addon height-34px">
                  Adómentesség: 
                </span>	
                <span className="input-group-addon"  key={"is_tax_exemption_" + is_tax_exemption}>
                  <input type="checkbox" name="is_tax_exemption" defaultChecked={ is_tax_exemption == 'yes' ? true : false } onChange = {(e) => this.tax_exemption_change()}/>
                </span>	
              </div>
              </div>
            </div>
            {
              this.state.tax_exemption &&
              <div className="col-md-8 form-group">
                <div className="input-group">
                <div className="input-group">
                  <select name="tax_exemption_type" key={"tax_exemption_type_" + tax_exemption_type} defaultValue={this.state.datas['tax_exemption_type'] ?? ''} className="form-control">
                  <option value="TAM">TAM - "tárgyi adómentes" ill. a tevékenység közérdekű vagy speciális jellegére tekintettel adómentes</option>
                  <option value="AAM">AAM - alanyi adómentes</option>
                  <option value="KBAET">KBAET - adómentes Közösségen belüli termékértékesítés, új közlekedési eszköz nélkül</option>
                  <option value="KBAUK">KBAUK - adómentes Közösségen belüli új közlekedési eszköz értékesítés</option>
                  <option value="EAM">EAM - adómentes termékértékesítés a Közösség területén kívülre (termékexport harmadik országba)</option>
                  <option value="NAM">NAM - egyéb nemzetközi ügyletekhez kapcsolódó jogcímen megállapított adómentesség</option>
                  <option value="FAD">FAD - fordított adózás</option>
                  <option value="AKK">AKK - Nincs felszámított áfa a 17. § alapján</option>
                  <option value="ATK">ATK - Áfa tárgyi hatályán kívül</option>
                  <option value="EUFAD37">EUFAD37 - Áfa tv. 37. §-a alapján másik tagállamban teljesített, fordítottan adózó ügylet</option>
                  <option value="EUFADE">EUFADE - Másik tagállamban teljesített, nem az Áfa tv. 37. §-a alá tartozó, fordítottan adózó ügylet</option>
                  <option value="EUE">EUE - Másik tagállamban teljesített, nem fordítottan adózó ügylet</option>
                  <option value="HO">HO - Harmadik országban teljesített ügylet</option>
                  <option value="TRAVEL_AGENCY">TRAVEL_AGENCY - Utazási irodák</option>
                  <option value="SECOND_HAND">SECOND_HAND - Használt cikkek</option>
                  <option value="ARTWORK">ARTWORK - Műalkotások</option>
                  <option value="ANTIQUES">ANTIQUES - Gyűjteménydarabok és régiségek</option>
                  </select>
                </div>
                </div>
              </div>
            }
            
              
            </div>
            <div className="row">
              
              <div className="col-md-6 form-group">
                <div className="input-group">
                  <input type="hidden" name="depedencies" defaultValue={this.joinObj(this.state.depedencies_selected)} className="form-control" />
                  <button className="btn btn-success btn-block">Mentés</button>
                </div>
              </div>
            </div>
          </form>
          <hr />
          <div className="row">
            <div className="col-md-12" key={"mainimage_" + this.state.main_image}>
              <div className="form-group">
                <label>Fő kép</label>
                <input type="file" className="form-control" onChange={(e) => {this.uploadMainImage(e)}} accept="image/png, image/jpeg" />
              </div>
              {
              this.state.main_image != '' && this.state.main_image != null ?
              <div className="form-group">
                <img src={'/' + this.state.main_image} />
              </div>
              :
              <>
              </>
              }
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-12" key={"mainimage_" + this.state.main_image}>
              <div className="form-group">
                <label>Galéria képek</label>
                <input type="file" className="form-control" onChange={(e) => {this.uploadGalleryImages(e)}} accept="image/png, image/jpeg" multiple />
              </div>
            </div>
          </div>
          <div className="row">
            {
            Object.keys(this.state.gallery).length > 0 ?
            <>
            {
              Object.keys(this.state.gallery).map((item) => {
                let img = this.state.gallery[item].image
                return (
                  <div className="col-md-4 " key={"gallery_" + this.state.gallery[item].id}>
                    <div className="gallery_item">
                      <img src={'/' + img} />
                      <button type="button" className="btn btn-danger btn-sm" title="Törlés" onClick={() => this.removeGalleryItem(this.state.gallery[item].id)}>x</button>
                    </div>
                  </div>
                )
              })
            }
            </>
            :
            <>
            </>
            }
          </div>
        </div>
      </div>
      </>)
    } else {
      return (<></>)
    }
  }

  private joinObj(obj){
    let out = [];
    Object.keys(obj).map((i) => {
      out.push(obj[i]);
    })
    return out.join(",");
  }
  private checkObjValue(obj, val){
    let found = Object.keys(obj).filter((key) => {
      return obj[key] === val;
    });
    return found.length ? true : false;
  }

}